import React from "react";
import { Link } from "gatsby"
import Container from "./container";
import PortableText from "./portableText";

import * as styles from "../styles/components/solution-pricing.module.css";

const SolutionPricing = (props) => {

  const {
    heading,
    _rawContent,
    solutions
  } = props;

  const solutionsCategories = [{title: 'Connect', slug:'connect-solutions'}, {title: 'Transform', slug: 'transform'}, {title: 'Enterprise', slug: 'enterprise'}]

  return (
    <div className={styles.root}>
      <Container>
        <div className="content-md">
          {heading && <h2 className="h3">{heading}</h2>}
          {_rawContent && <PortableText blocks={_rawContent} />}
        </div>
        {solutionsCategories.map((category) => {
          return (
            <div id={category.title} key={category.slug} className={styles.category}>
              <h4>{`Solutions Available with ${category.title} License`}</h4>
              <div className={styles.tableWrap}>
                <table className={styles.table}>
                  <thead>
                    <tr>
                      <th className={styles.colTitle}>Solution</th>
                    </tr>
                  </thead>
                  <tbody>
                    {solutions.filter(solution => solution.category.title === category.title).map(solution => {
                      return (
                        <tr key={solution._key}>
                          <td>
                            <Link to={`/solutions/${category.slug}/${solution.slug.current}`}>{solution.pageHeader.title}</Link>
                            {solution.pageHeader.description &&
                              <p>{solution.pageHeader.description}</p>
                            }
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )
        })}
      </Container>
    </div>
  );
}

export default SolutionPricing;
